import { sharePopupToggle } from '../components/LogoBlock/sharePopupToggle';
import dropdownMenu from '../components/DropdownMenu/dropdownMenuJs';
import searchToggle from '../components/SearchBar/searchToggle';
import tabs from '../components/Tabs/tabsJs';
import articleJs from '../components/Article/articleJs';
import headerJs from '../components/Header/HeaderJs';
import sliderJs from '../components/Slider/sliderJs';
import SubscribeWidgetJs from '../components/SubscribeWidget/SubscribeWidgetJs';
import forumsBadge from '../components/ForumsBadge/ForumsBadge';

import offcanvasJs from '../components/OffCanvas/offcanvasJs';

window.sharePopupToggle = sharePopupToggle;

// Adthrive code
// body by default is set to cafemedia-no-footer-desktop
		var body = document.body;
		if(window.forum_logged_in == true)
                        {
                            // logged in users get special class
                                body.classList.remove('cafemedia-no-footer');
                                body.classList.remove('cafemedia-no-footer-desktop-728');
                                body.classList.remove('cafemedia-fewer');
                                body.classList.add('cafemedia-logged-in');
                        }
                else
                    	{
                                var mr_count = window.getCookie("xf_mr_count");
                                if (mr_count>0)
                                        {
                                                mr_count++;
                                                window.setCookie('xf_mr_count', mr_count);
                                        }
                                else
                                    	{
                                                window.setCookie('xf_mr_count', '1');
                                        }
                            
                                        if (location.hostname=='buyersguide.macrumors.com')
                                        {
                                        // footer is ok for buyersguide desktop
//                                        body.classList.remove('cafemedia-no-footer-desktop-728');
                                        }
                                if (window.location.href.indexOf("/roundup/") > -1) 
                                        {       
                                        body.classList.remove('cafemedia-no-footer-desktop-728');
                                        body.classList.add('cafemedia-no-header-desktop');
                                        }
                                if (window.location.href == "https://www.macrumors.com/")
                                        {
                                        body.classList.remove('cafemedia-fewer');
                                        }

                            }
                if (window.lightdark)
                            {
                                body.classList.add('cafemedia-dark');
                            }
                if (getCookie("xf_contributor")>1)
                {
                        var element = document.getElementById("nonaiblurb");
                        element.style.display = "none";
                        var element = document.getElementById("buyersaiintro");
                        element.style.display = "block";
                }

                
// var cookieName = '__utma';
// var cookieValue = getCookie(cookieName);
// if (cookieValue == '') console.log(cookieName + " doesn't exist");
// else console.log(cookieName + ' exists');


{/*
        var mrexpand = getCookie("mr-expand");
        if (mrexpand)
        {
            $("div.article").find(".desktopExpandWrap").css("opacity",0);
            $("div.article").addClass("expanded");
            $("div.article").find(".content").css("max-height","none");
            $(".desktopExpandWrap").css('opacity', 0);
            $(".desktopExpandWrap").css("visibility", "hidden");
        }
        */}

if (getCookie("mr-expand")==1)
{
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = '.js-expandWrap {display:none;} .js-content {max-height:none !important;}';
    document.getElementsByTagName('head')[0].appendChild(style);

}